import { Component, ElementRef, inject, NgZone, OnDestroy, OnInit, Renderer2, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './auth/auth.service';
import { ErrorStore } from './store/error.store';
import { UpdateBar } from './pwa/components/update-bar/update-bar';
import { GtmService } from './services/gtm.service';

@Component({
    selector: 'app-root',
    imports: [
        RouterOutlet,
        UpdateBar
    ],
    templateUrl: './app.html',
    styleUrl: './app.scss',
})
export class App implements OnInit, OnDestroy {
    protected readonly title = signal('HAL');
    protected isLoading: boolean = false;
    protected isAuthenticated = signal(false);
    protected isLoaded = signal(false);
    protected userEmail = signal<string | null>(null);

    private _authService = inject(AuthService);
    private _errorStore = inject(ErrorStore);
    // private swUpdate = inject(SwUpdate);
    private readonly _gtmService = inject(GtmService);
    private resizeListener?: () => void;

    constructor(private el: ElementRef, private renderer: Renderer2) {}

    public ngOnInit(): void {
        this._authService.isAuthenticated().subscribe((value) => {
            this.isAuthenticated.set(value);
        });
        this._authService.loggedUser.subscribe((user) => {
            this.userEmail.set(user.email);
        });
        this.isLoaded.set(true);
        this._gtmService.initGTM();

        if (window.visualViewport) {
            this.resizeListener = this.onViewportResize.bind(this);
            window.visualViewport.addEventListener('resize', this.resizeListener);
        }
    }

    public ngOnDestroy(): void {
        if (window.visualViewport && this.resizeListener) {
            window.visualViewport.removeEventListener('resize', this.resizeListener);
        }
    }

    private onViewportResize() {
        if (!window.visualViewport) {
            return;
        }
        const height = window.visualViewport.height;
        this.renderer.setStyle(this.el.nativeElement.ownerDocument.body, 'height', `${height}px`);
    }
}
